<template>
    <div class="flex_1 margin_horizontal">
		<AccessRestrictedButtonGroup v-show="false"
									 class="flex flex_center table_button_group"
									 v-model="activeButton"
									 :elements="buttonGroupTypes"
									 :session-key="$route.path"
		/>
        <el-tabs class="table_tabs margin_top" v-model="activeAccountTab">
            <el-tab-pane v-for="account in accountList"
                         :name="String(account.id)"
                         :key="account.id"
            >
                <el-tooltip slot="label" popper-class="tooltip-md" placement="bottom"
                            :content="$t('common.account.deactivated')"
                            :disabled="account.enabled"
                            :open-delay="750"
                >
                        <span>
                            <i v-if="!account.enabled" class="fa fa-ban"></i>
                            {{formatAccountDisplay(account)}}
                        </span>
                </el-tooltip>
            </el-tab-pane>
        </el-tabs>
        <AllInvestmentsReceivablesTable
			v-if="activeButton === buttonGroupTypes.receivableInvestments"
			:accountId="activeAccountId"
			:accounts-assigned="accountsAssigned"
        />
    </div>
</template>

<script>
import {allInvestmentsReceivablesApi} from "@/common/api/allInvestmentsReceivablesApi";
import AllInvestmentsReceivablesTable
	from "@/components/templates/investor/allInvestments/receivables/AllInvestmentsReceivablesTable";
import {enumDef} from "@/common/enumDefs";
import AllInvestmentsRevolvingPutOptionsTable
	from "@/components/templates/investor/allInvestments/revolving/AllInvestmentsRevolvingPutOptionsTable";
import AccessRestrictedButtonGroup from "@/components/templates/common/permissions/AccessRestrictedButtonGroup";
import {navigationTabs} from "@/common/navigation/navigationTabs";

export default {
    components: {
		AccessRestrictedButtonGroup,
        AllInvestmentsReceivablesTable,
		AllInvestmentsRevolvingPutOptionsTable,
    },
    data() {
		let buttonGroupTypes = {
			receivableInvestments: {
				name: navigationTabs.investor.investments.receivables,
				translationKey: "allInvestments.tradeReceivables",
				api: allInvestmentsReceivablesApi,
				permission: enumDef.permissions.InvestorExchangeReceivables
			},
		};

        return {
			activeButton: null,
			buttonGroupTypes: buttonGroupTypes,
            accountList: null,
            activeAccountTab: "-1",
        };
    },
    computed: {
        activeAccountId() {
            return Number(this.activeAccountTab);
        },
        accountsAssigned() {
            return this.accountList === null || this.accountList.length > 0;
        },
    },
    methods: {
        getAccounts() {
			this.activeButton.api.inspection.getAccounts()
                .then(res => {
                    this.accountList = res;

                    if (this.accountList.length > 0) {
						this.activeAccountTab = this.$store.getters["session/activeTabs"][this.$route.path.concat("&account")] || String(res[0].id);
                    }
                })
                .catch(this.toast);
        },
        formatAccountDisplay(account) {
            return (account.tag || account.tbIban) + " (" + account.tbCurrType + ")";
        }
    },
	watch: {
    	activeButton() {
    		this.getAccounts();
		},
		activeAccountTab() {
			this.$store.dispatch("session/setActiveTab", { tabGroup: this.$route.path.concat("&account"), activeTab: this.activeAccountTab });
		},
	}
};
</script>
